import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Body from 'syf-component-library/ui/typography/Body';
import { useEffect } from 'react';
import { SyfLoader } from 'syf-component-library/ui/atoms';
import RadioCard from '../../components/cards/RadioCard';
import useSteps from '../../context/steps.context';
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import useTypesafeAnswer from '../../hooks/useTypesafeAnswer';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import { t } from '../../translations/getTranslation';
import useCardEligibilityQuery from '../../hooks/useCardEligibility';
import globalTheme from '../../theme';
import FreezeCard from '../../components/cards/FreezeCard';
import spreadIf from '../../helpers/spreadIf';
import useFeatureFlagsQuery from '../../hooks/useFeatureFlagsQuery';
const Fieldset = styled.fieldset `
  all: unset;
`;
const LoadingWrapper = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const CustomRadioCard = styled(RadioCard) `
  margin-top: ${() => globalTheme.spacing.base}px;
`;
const SubText = styled(Body) `
  margin-top: ${() => globalTheme.spacing.large}px;
  text-align: center;
`;
const RequestReplacementButton = styled.button `
  color: ${({ theme }) => theme.colors.cyanBlue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
const ReasonSelectionLostCard = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    const { stepsState: { error }, stepsDispatch } = useSteps();
    const { data: featureFlags } = useFeatureFlagsQuery();
    const activeStep = 'ReasonSelectionLostCard';
    const { currentAnswer } = useTypesafeAnswer(activeStep);
    const errorText = t('reasonSelection.makeASelection');
    const reasonOptions = [
        {
            headingKey: 'reasonSelectionLostStolen.misplacedCardHeading',
            descriptionKey: 'reasonSelectionLostStolen.misplacedCardBody',
            value: 'misplaced-card-in-home'
        },
        {
            headingKey: 'reasonSelectionLostStolen.lostCardHeading',
            descriptionKey: 'reasonSelectionLostStolen.lostCardBody',
            value: 'lost-card'
        },
        {
            headingKey: 'reasonSelectionLostStolen.stolenCardHeading',
            descriptionKey: 'reasonSelectionLostStolen.stolenCardBody',
            value: 'stolen-card'
        }
    ];
    const handleReasonChange = (event) => {
        const reason = event.currentTarget.value;
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: activeStep, value: reason }
        });
    };
    const handleCardClick = (value) => {
        const reason = value;
        if (reason === (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value)) {
            return;
        }
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: activeStep, value: reason }
        });
    };
    useAnalytics(isSuccess, {
        isSemu,
        error
    });
    const { data: eligibleCards, isLoading: isEligibleCardLoading } = useCardEligibilityQuery();
    useEffect(() => {
        if (!isEligibleCardLoading && !(eligibleCards === null || eligibleCards === void 0 ? void 0 : eligibleCards.cards.length)) {
            stepsDispatch({ type: 'updateStep', payload: 'CantProcess' });
        }
    }, [isEligibleCardLoading, eligibleCards === null || eligibleCards === void 0 ? void 0 : eligibleCards.cards.length, stepsDispatch]);
    const handleRequestReplacement = () => {
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'toggleFlow'
        });
    };
    if (isEligibleCardLoading)
        return (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) }));
    const showFreezeAccountBanner = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showFreezeAccountBanner;
    return (_jsxs("div", Object.assign({ "data-cy": "reason-selection-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ maxWidth: 408 }, { children: [_jsxs(Fieldset, { children: [_jsx("legend", { children: _jsx(LayoutHeading, Object.assign({ title: t('reasonSelection.pleaseTellUsMore') }, spreadIf([error, { errorText }]))) }), showFreezeAccountBanner && _jsx(FreezeCard, {}), reasonOptions.map(({ headingKey, descriptionKey, value }) => (_jsx(CustomRadioCard, { headingLabel: t(headingKey), description: t(descriptionKey), radioProps: {
                                    id: value,
                                    name: 'reason-selection',
                                    value,
                                    checked: (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value) === value,
                                    /* @ts-expect-error TODO: fix handle typing in CL. */
                                    onChange: handleReasonChange,
                                    children: null,
                                    hasError: !!error
                                }, onClick: () => handleCardClick(value) }, value)))] }), _jsxs(SubText, { children: [t('reasonSelectionLostStolen.cardDamaged'), _jsx(RequestReplacementButton, Object.assign({ onClick: handleRequestReplacement }, { children: t('reasonSelectionLostStolen.requestReplacement') }))] })] }))] })));
};
export default ReasonSelectionLostCard;
//# sourceMappingURL=index.js.map